/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkPackageFieldsSchemaRequest } from '../../models/create-work-package-fields-schema-request';
import { WorkPackageFieldsSchemaDto } from '../../models/work-package-fields-schema-dto';

export interface CreateWorkPackageFieldsSchema$Params {
      body: CreateWorkPackageFieldsSchemaRequest
}

export function createWorkPackageFieldsSchema(http: HttpClient, rootUrl: string, params: CreateWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackageFieldsSchema.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageFieldsSchemaDto>;
    })
  );
}

createWorkPackageFieldsSchema.PATH = '/v0/WorkPackageFieldsSchema/{id}';
